/**
 * CMCD Version 1
 *
 *
 * @beta
 */
export const CMCD_V1 = 1
